/**
Good News ! JV.FriendWidget.js got pregnant and delivered a baby. Its called jv.friendWidgetMin.js.
I have pulled out functions I need from that file instead of bringing in that huge file to be used on details.jsp-
We should delete this file when we redo the quickview -- NV
**/

/**
The utility is used to show the ghost text for a particular field.
@param1 : id of the element
@param2 : text that should be highlighted
@param3 : type is an enum("TEXT", "PASSWORD"), default is the TEXT.
*/

function addGhostText(id, txt, type) {
    var element = $("#" + id);
    var _txt = txt;
    var _type = type;
    var p_classes = null;
    var p_id = null;
    var p_element = null;

    if (type == "PASSWORD") {
        p_classes = $(element).attr("class");
        p_id = $(element).attr("id");
        p_element = element;
        //element = $("<input type='text' class='" + p_classes + "' id='" + p_id + "'>");
        $(element).after("<input type='text' class='" + p_classes + "' id='" + p_id + "'>");
        var _element = $(element).next();
        $(element).remove();
        element = _element;
    }

    // Do not add the value if there is already some value available.
    if (element.val() !== undefined && typeof element.val() === 'string' && element.val().trim() == '') {
        element.css({ "color": "#cccccc" });
        element.val(txt);
    }

    var setStyleOnFocus = function () {
        if ($(this).val() == _txt && ($(this).css("color") == "#cccccc" || $(this).css("color") == "rgb(204, 204, 204)")) {
            $(this).css({ "color": "#000000" }).val("");
            if (_type == "PASSWORD") {
                $(this).before(p_element).remove();
                $(p_element).css({ "color": "#000000" }).focus();
            }
        }
    };

    var setStyleOnBlur = function () {
        var value = ($(this).val()).replace(/(^\s*)|(\s*$)/g, '');
        if (value == "") {
            $(this).css({ "color": "#cccccc" }).val(_txt);
        }
    };
    element.on('focus', setStyleOnFocus);
    element.on('blur', setStyleOnBlur);
}




(function ($) {
    $.fn.jqDrag = function (h) {
        return i(this, h, 'd');
    };
    $.fn.jqResize = function (h) { return i(this, h, 'r'); };
    $.jqDnR = {
        dnr: {},
        e: 0,
        drag: function (v) {
            var _top = M.Y + v.pageY - M.pY;
            _top = _top > 0 ? _top : 0;
            if (M.k == 'd') E.css({
                left: M.X + v.pageX - M.pX, top: _top
            });
            else E.css({
                width: Math.max(v.pageX - M.pX + M.W, 0), height: Math.max(v.pageY - M.pY + M.H, 0)
            });
            return false;
        },

        stop: function () {
            //E.css('opacity',M.o);
            $(document).off('mousemove').off('mouseup');
        }
    };
    var J = $.jqDnR, M = J.dnr, E = J.e,
        i = function (e, h, k) {
            return e.each(function () {
                h = (h) ? $(h, e) : e;
                h.live('mousedown', { e: e, k: k }, function (v) {
                    var d = v.data, p = {}; E = d.e;
                    // attempt utilization of dimensions plugin to fix IE issues
                    if (E.css('position') != 'relative') {
                        try {
                            E.position({}, p);
                        } catch (e) { }
                    }
                    M = {
                        X: p.left || f('left') || 0, Y: p.top || f('top') || 0, W: f('width') || E[0].scrollWidth || 0, H: f('height') || E[0].scrollHeight || 0, pX: v.pageX, pY: v.pageY, k: d.k//,o:E.css('opacity')
                    };
                    //          E.css({
                    //              opacity:0.8
                    //          });
                    $(document).mousemove(function (e) {
                        $.jqDnR.drag(e)
                    }).mouseup(function (e) {
                        $.jqDnR.stop(e)
                    });
                    return false;
                });
            });
        },
        f = function (k) {
            //return parseInt(E.css(k))||false;
        };
})(jQuery);






/*

 jQuery Tools 1.2.5 Tooltip - UI essentials

 NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.

 http://flowplayer.org/tools/tooltip/

 Since: November 2008
 Date:    Wed Sep 22 06:02:10 2010 +0000
*/
(function (f) {
    function p(a, b, c) {
        var h = c.relative ? a.position().top : a.offset().top, d = c.relative ? a.position().left : a.offset().left, i = c.position[0];
        h -= b.outerHeight() - c.offset[0];
        d += a.outerWidth() + c.offset[1];
        if (/iPad/i.test(navigator.userAgent))
            h -= f(window).scrollTop();
        var j = b.outerHeight() + a.outerHeight();
        if (i == "center")
            h += j / 2;
        if (i == "bottom")
            h += j;
        i = c.position[1];
        a = b.outerWidth() + a.outerWidth();
        if (i == "center")
            d -= a / 2;
        if (i == "left")
            d -= a;
        return {
            top: h,
            left: d
        }
    }
    function u(a, b) {
        var c = this, h = a.add(c), d, i = 0, j = 0, m = a.attr("title"), q = a.attr("data-tooltip"),
            r = o[b.effect], l, s = a.is(":input"), v = s && a.is(":checkbox, :radio, select, :button, :submit"),
            t = a.attr("type"), k = b.events[t] || b.events[s ? v ? "widget" : "input" : "def"];
        if (!r)
            throw 'Nonexistent effect "' + b.effect + '"';
        k = k.split(/,\s*/);
        if (k.length != 2)
            throw "Tooltip: bad events configuration for " + t;
        a.on(k[0], function (e) {
            clearTimeout(i);
            if (b.predelay)
                j = setTimeout(function () {
                    c.show(e)
                }, b.predelay);
            else
                c.show(e)
        }).on(k[1], function (e) {
            clearTimeout(j);
            if (b.delay)
                i = setTimeout(function () {
                    c.hide(e)
                }, b.delay);
            else
                c.hide(e)
        });
        if (m && b.cancelDefault) {
            a.removeAttr("title");
            a.data("title", m)
        }
        f.extend(c, {
            show: function (e) {
                if (!d) {
                    if (q)
                        d = f(q);
                    else
                        if (b.tip)
                            d = f(b.tip).eq(0);
                        else
                            if (m)
                                d = f(b.layout).addClass(b.tipClass).appendTo(document.body).hide().append(m);
                            else {
                                d = a.next();
                                d.length || (d = a.parent().next())
                            }
                    if (!d.length)
                        throw "Cannot find tooltip for " + a;
                }
                if (c.isShown())
                    return c;
                d.stop(true, true);
                var g = p(a, d, b);
                b.tip && d.html(a.data("title"));
                e = e || f.Event();
                e.type = "onBeforeShow";
                h.trigger(e, [g]);
                if (e.isDefaultPrevented())
                    return c;
                g = p(a, d, b);
                d.css({
                    position: "absolute",
                    top: g.top,
                    left: g.left
                });
                l = true;
                r[0].call(c, function () {
                    e.type = "onShow";
                    l = "full";
                    h.trigger(e)
                });
                g = b.events.tooltip.split(/,\s*/);
                if (!d.data("__set")) {
                    d.on(g[0], function () {
                        clearTimeout(i);
                        clearTimeout(j)
                    });
                    g[1] && !a.is("input:not(:checkbox, :radio), textarea") && d.on(g[1], function (n) {
                        n.relatedTarget != a[0] && a.trigger(k[1].split(" ")[0])
                    });
                    d.data("__set", true)
                }
                return c
            },
            hide: function (e) {
                if (!d || !c.isShown())
                    return c;
                e = e || f.Event();
                e.type = "onBeforeHide";
                h.trigger(e);
                //VA: The value of l was never changing so it was never following the
                //show condition after the element was hidden.
                //l = false;
                if (!e.isDefaultPrevented()) {
                    l = false;
                    o[b.effect][1].call(c, function () {
                        e.type = "onHide";
                        h.trigger(e)
                    });
                    return c
                }
            },
            isShown: function (e) {
                return e ? l == "full" : l
            },
            getConf: function () {
                return b
            },
            getTip: function () {
                return d
            },
            getTrigger: function () {
                return a
            }
        });
        f.each("onHide,onBeforeShow,onShow,onBeforeHide".split(","), function (e, g) {
            typeof b[g] === 'function' && f(c).on(g, b[g]);
            c[g] = function (n) {
                n && f(c).on(g, n);
                return c
            }
        })
    }





    f.tools = f.tools ||
    {
        version: "1.2.5"
    };
    f.tools.tooltip = {
        conf: {
            effect: "toggle",
            fadeOutSpeed: "fast",
            predelay: 0,
            delay: 30,
            opacity: 1,
            tip: 0,
            position: ["top", "center"],
            offset: [0, 0],
            relative: false,
            cancelDefault: true,
            events: {
                def: "mouseenter,mouseleave",
                input: "focus,blur",
                widget: "focus mouseenter,blur mouseleave",
                tooltip: "mouseenter,mouseleave"
            },
            layout: "<div/>",
            tipClass: "tooltip"
        },
        addEffect: function (a, b, c) {
            o[a] = [b, c]
        }
    };
    var o = {
        toggle: [function (a) {
            var b = this.getConf(), c = this.getTip();
            b = b.opacity;
            b < 1 && c.css({
                opacity: b
            });
            c.show();
            a.call()
        }, function (a) {
            this.getTip().hide();
            a.call()
        }
        ],
        fade: [function (a) {
            var b = this.getConf();
            this.getTip().fadeTo(b.fadeInSpeed, b.opacity, a)
        }, function (a) {
            this.getTip().fadeOut(this.getConf().fadeOutSpeed, a)
        }
        ]
    };
    f.fn.jvtooltip = function (a) {
        var b = this.data("tooltip");
        if (b)
            return b;
        a = f.extend(true, {}, f.tools.tooltip.conf, a);
        if (typeof a.position == "string")
            a.position = a.position.split(/,?\s/);
        this.each(function () {
            b = new u(f(this), a);
            f(this).data("tooltip", b)
        });
        return a.api ? b : this
    }
})(jQuery);



/*
 jQuery Tools 1.2.5 / Tooltip Dynamic Positioning
 NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.
 http://flowplayer.org/tools/tooltip/dynamic.html
 Since: July 2009
 Date:    Wed Sep 22 06:02:10 2010 +0000
*/
(function (g) {
    function j(a) { var c = g(window), d = c.width() + c.scrollLeft(), h = c.height() + c.scrollTop(); return [a.offset().top <= c.scrollTop(), d <= a.offset().left + a.width(), h <= a.offset().top + a.height(), c.scrollLeft() >= a.offset().left] } function k(a) { for (var c = a.length; c--;)if (a[c]) return false; return true } var i = g.tools.tooltip; i.dynamic = { conf: { classNames: "top right bottom left" } }; g.fn.dynamic = function (a) {
        if (typeof a == "number") a = { speed: a }; a = g.extend({}, i.dynamic.conf, a); var c = a.classNames.split(/\s/), d; this.each(function () {
            var h =
                g(this).jvtooltip().onBeforeShow(function (e, f) {
                    e = this.getTip(); var b = this.getConf(); d || (d = [b.position[0], b.position[1], b.offset[0], b.offset[1], g.extend({}, b)]); g.extend(b, d[4]); b.position = [d[0], d[1]]; b.offset = [d[2], d[3]]; e.css({ visibility: "hidden", position: "absolute", top: f.top, left: f.left }).show(); f = j(e); if (!k(f)) {
                        if (f[2]) { g.extend(b, a.top); b.position[0] = "top"; e.addClass(c[0]) } if (f[3]) { g.extend(b, a.right); b.position[1] = "right"; e.addClass(c[1]) } if (f[0]) { g.extend(b, a.bottom); b.position[0] = "bottom"; e.addClass(c[2]) } if (f[1]) {
                            g.extend(b,
                                a.left); b.position[1] = "left"; e.addClass(c[3])
                        } if (f[0] || f[2]) b.offset[0] *= -1; if (f[1] || f[3]) b.offset[1] *= -1
                    } e.css({ visibility: "visible" }).hide()
                }); h.onBeforeShow(function () { var e = this.getConf(); this.getTip(); setTimeout(function () { e.position = [d[0], d[1]]; e.offset = [d[2], d[3]] }, 0) }); h.onHide(function () { var e = this.getTip(); e.removeClass(a.classNames) }); ret = h
        }); return a.api ? ret : this
    }
})(jQuery);





module.exports = { addGhostText };